<!----Dev: Uncomment if required, rightnow no details from an API---->
<!-- <button class="!k-p-1" [svgIcon]="location" fillMode="flat" kendoButton kendoPopoverAnchor title="Location"
          [popover]="locationPopover" size="medium">
          </button>
        <kendo-popover #locationPopover>
          <ng-template kendoPopoverBodyTemplate>
            <p class="label secondary-color font-12 !k-my-1">Physical DBN</p>
            <p style="font-weight: 600;" class="!k-my-1">[{{studentData?.dbn}}] School Name</p>
            <p class="!k-my-1">prem@gmail.com
              <button class="!k-p-1" [svgIcon]="copy" fillMode="flat" kendoButton kendoPopoverAnchor title="Copy"
              size="medium" (click)="copyClipboard('prem@gmail.com')"></button>
          </p>
          </ng-template>
        </kendo-popover>
      </div> -->
<!-- <div class="col">
        <p class="label secondary-color font-12">Assigned To</p>
        <div *ngIf="studentData?.assigned && studentData?.caseAssdFirstName && studentData?.caseAssdLastName">
          <p>{{ studentData?.caseAssdFirstName+' '+studentData?.caseAssdLastName}}
            <button class="!k-p-0" [svgIcon]="addressBook" fillMode="flat" kendoButton kendoPopoverAnchor
              title="Contact" #popoverAnchor="kendoPopoverAnchor" (click)="popoverAnchor.show()"
              [popover]="addressPopover" size="medium">
            </button>
          </p>

          <kendo-popover #addressPopover>
            <ng-template kendoPopoverBodyTemplate>
              <div class="!k-d-flex k-justify-content-between  k-align-items-end">
                <p style="font-weight: 600;" class="!k-my-0">{{ studentData?.caseAssdFirstName+'
                  '+studentData?.caseAssdLastName}}</p>

                <button kendoButton fillMode="flat" [svgIcon]="xIcon" size="small" (click)="popoverAnchor.hide()"
                  title="Close"></button>
              </div>
                <p class="caseAssdRole k-my-1">{{studentData?.caseAssdRole}}</p>
              <p class="!k-mt-0 !k-mb-3">{{studentData?.caseAssdEmail}}
                <button class="!k-p-0" [svgIcon]="copy" fillMode="flat" kendoButton size="medium"
                  (click)="copyClipboard(studentData?.caseAssdEmail)" title="Copy">
                </button>
              </p> -->
<!-- <p class="!k-mt-1">prem@gmail.com Dev: Undo if required in student header also, commented as backend dev suggested that no email in student header.
              <button class="!k-p-1" [svgIcon]="copy" fillMode="flat" kendoButton size="medium" (click)="copyClipboard(studentData?.caseAssdEmail)" title="Copy">
              </button>
            </p> -->
<!-- </ng-template>
          </kendo-popover>
        </div>
        <div *ngIf="!studentData?.assigned" class="!k-mt-1">
          <span class="k-font-semibold k-text-error">Unassigned</span>
          <button kendoButton *ngIf="user?.isGlobalUser" tabindex="0"
            class="!k-p-0 k-text-primary k-cursor-pointer assign-btn" fillMode="link"
            (click)="showReAssign$.next(true)">(Assign)</button>
        </div>
      </div>
      <div class="col" *ngIf="isPreschool">
        <p class="label secondary-color font-12">Evaluation Site</p>
        <p>{{ studentData?.evaluationSite }}</p>
      </div>

      <div class="activity-col">
        <p class="label secondary-color font-12">Activity</p>
        <b>{{ studentData?.caseStage }}: </b><p class="previous-activity"><ng-container *ngFor="let activityPart of formatPreviousActivity(studentData?.activity); let first = first"><br *ngIf="!first" />{{ activityPart }}</ng-container></p>
    <span *ngIf="studentData?.prevActivity"><b>{{ getActivityLabel(studentData?.caseStage) }}: </b><p class="previous-activity"><ng-container *ngFor="let activityPart of formatPreviousActivity(studentData?.prevActivity); let first = first"><br *ngIf="!first" />{{ activityPart }}</ng-container></p></span>
    
      </div>
      <div class="date-cols">
        <p class="label secondary-color font-12">Activity Due Date</p>
        <ng-container *ngIf="dueDatesArray?.length">
          <ng-container *ngFor="let obj of dueDatesArray">
            <b><span data-qa="compliance-date-type">
            {{ getReferralType(obj?.referraltype) }}:
          </span></b>
            <p class="font-14" [class.at-risk]="studentData.complianceStatus === 'At Risk'" [class.k-text-error]="
                studentData.complianceStatus === 'Out of Compliance'">
              <fa-icon *ngIf="studentData.complianceStatus === 'At Risk'" [icon]="circleExclamation"
                title="At Risk"></fa-icon>
              <fa-icon *ngIf="studentData.complianceStatus === 'Out of Compliance'" icon="triangle-exclamation"
                title="Out of compliance"></fa-icon>
              <fa-icon *ngIf="studentData.complianceStatus === 'Reason for Delay'" icon="business-time"
                title="Reason for Delay"></fa-icon>
              {{ obj?.descr }}: {{ obj?.date }}<br />
              ({{ obj?.days }} {{ getDayLabel(obj?.days) }})
            </p>
          </ng-container>
        </ng-container>
      </div>
      <div class="date-cols">
        <p class="label secondary-color font-12">Compliance Date</p>
        <ng-container *ngIf="complianceDatesArray?.length">
          <ng-container *ngFor="let obj of complianceDatesArray">
            <b><span data-qa="compliance-date-type">
            {{ getReferralType(obj?.referraltype) }}:
          </span></b>
        <p class="font-14" [class.k-text-error]="obj?.days?.startsWith('-')">
              <fa-icon *ngIf="obj?.days?.startsWith('-')" icon="triangle-exclamation"></fa-icon>
              {{ obj?.descr }}: {{ obj?.date }}<br />
              ({{ obj?.days }} {{ getComplianceDayLabel(obj?.days) }})
            </p>
          </ng-container>
        </ng-container>
      </div> -->

<div class="k-d-flex k-gap-4 k-justify-content-end">
  <kendo-dropdownbutton themeColor="base" class="btnChange" [data]="manageStudentsData"
    *ngIf="showEditStudentInformation && showManageButton" (itemClick)="onSelect($event)" size="large" rounded="large"
    fillMode="solid">
    Manage
  </kendo-dropdownbutton>
  <div class="actions-col" *ngIf="showAction && isStudentSKValid()">
    <button size="large" kendoButton #anchor [themeColor]="'primary'" fillMode="solid" (click)="loadActions($event)">
      <kendo-loader *ngIf="loading.actions" size="small"> </kendo-loader>
      Actions
      <kendo-contextmenu [target]="anchor" size="large" showOn="click">
        <ng-template kendoContextMenuTemplate>
          <app-custom-actions [actionsList]="actionsList" [studentDetails]="studentData"
            (scheduleMeetingDialog)="showScheduleMeetingDialog$.next($event)"
            (cancelMeetingDialog)="showCancelMeetingDialog$.next($event)"
            (closeRequestForReevaluationDialog)="showCloseRequestForReevaluationDialog$.next($event)"
            (caseClosingEventsDialog)="showCaseClosingEventsDialog$.next($event)"
            (captureFirstAttendDate)="showCaptureFirstAttendDate$.next($event)" (reAssign)="showReAssign$.next($event)"
            (uploadDialog)="showUpload$.next($event)" (amendIEPDialog)="openAmendDialog($event)"
            (annualIEPDialog)="openAnnualDialog($event)"
            (removeFromMDEWorklistDialog)="openRemoveMDEWorklistDialog($event)" (meetingType)="meetingType = $event"
            (meetingSk)="meetingSk = $event" (isViewMode)="isViewMode = $event" (actionText)="actionText = $event"
            (meetingRoster)="meetingRoster = $event" (pwn)="pwn = $event" (isReAssign)="isReAssign = $event"
            (rfdDialog)="displayRfdDialog($event)"
                (createIepLoading)="isCreatingIep = $event">
          </app-custom-actions>
        </ng-template>
      </kendo-contextmenu>
    </button>
    <div #container></div>
  </div>
</div>
<!-- </div>
  </div>
</div> -->
<div class="new-student-info-container">
  <div class="student-summary-container" [class.red-alert-header]="redAlertContact"
    [class.case-closed-header]="isCaseClosed" *ngIf="studentDetails">
    <div class="student-avatar" [class.avatar-red-alert]="redAlertContact" [class.avatar-inactive]="isCaseClosed">
      <fa-icon icon="user-graduate" class="avatar-fa-icon"></fa-icon>
    </div>

    <div class="student-summary-card">
      <div class="student-basic-info">
        <div class="student-details">
          <div class="d-flex align-items-center gap-2">
            <h1 class="margin-0" style="display:inline-block; font-size: 1.25rem; font-weight: bold;">
              {{ studentData?.lastName }}
              {{ studentData?.firstName }}
            </h1>
            <span *ngIf="studentDetails?.eiId !== null" class="tag">EI</span>
            <span *ngIf="studentData?.hasKIP" class="tag secondary">KIP</span>
            <span *ngIf="redAlertContact" class="red-alert-badge">
              Red Alert
            </span>
            <span *ngIf="isCaseClosed" class="inactive-badge"> Inactive </span>
          </div>

          <p class="secondary-color">
            ID: {{ studentData?.nycid }} | <span aria-hidden="true">DOB</span><span class="k-sr-only">Date of
              birth</span>:
            <span [attr.aria-label]="studentData?.dob ? (studentData?.dob | date : 'MMMM d, y') : ''">
              <span aria-hidden="true">{{ (studentData?.dob | slice:0:10) | date:'MM/dd/yyyy' }}</span>
            </span> | Grade:
            {{ studentData?.gradeValue || studentDetails?.gradeValue }} | DBN:
            {{ studentData?.dbn }} | District:
            {{ studentData?.district }}
          </p>
        </div>
      </div>
      <div class="student-iep-info">
        <div class="info-block">
          <p class="info-label">Disability Classification</p>
          <p class="info-value">{{ studentIEP?.classification }}</p>
        </div>

        <div class="info-block">
          <p class="info-label">IEP Placement Recommendation</p>
          <p class="info-value">
            <span aria-hidden="true">{{ studentIEP?.placementRecommendations }}</span>
            <span class="k-sr-only" *ngIf="studentIEP?.placementRecommendations">{{
              expandAbbreviations(studentIEP?.placementRecommendations) }}</span>
          </p>
        </div>

        <div class="info-block">
          <p class="info-label">Assigned To</p>
          <div *ngIf="
            studentData?.assigned &&
            studentData?.caseAssdFirstName &&
            studentData?.caseAssdLastName
          ">
            <p class="info-value">
              {{
              studentData?.caseAssdFirstName +
              " " +
              studentData?.caseAssdLastName
              }}
              <button class="!k-p-0" [svgIcon]="addressBook" fillMode="flat" kendoButton kendoPopoverAnchor
                title="Assign to Contact" #popoverAnchor="kendoPopoverAnchor" (click)="popoverAnchor.show()"
                [popover]="addressPopover" size="medium"></button>
            </p>

            <kendo-popover #addressPopover>
              <ng-template kendoPopoverBodyTemplate>
                <div class="!k-d-flex k-justify-content-between k-align-items-end">
                  <p style="font-weight: 600" class="!k-my-0">
                    {{
                    studentData?.caseAssdFirstName +
                    "
                    " +
                    studentData?.caseAssdLastName
                    }}
                  </p>

                  <button kendoButton fillMode="flat" [svgIcon]="xIcon" size="small" (click)="popoverAnchor.hide()"
                    title="Close"></button>
                </div>
                <p class="!k-mt-0 !k-mb-3">
                  {{ studentData?.caseAssdEmail }}
                  <button class="!k-p-0" [svgIcon]="copy" fillMode="flat" kendoButton size="medium"
                    (click)="copyClipboard(studentData?.caseAssdEmail)" title="Copy"></button>
                </p>
              </ng-template>
            </kendo-popover>
          </div>
          <div *ngIf="!studentData?.assigned" class="!k-mt-1">
            <span class="k-font-semibold k-text-error">Unassigned</span>
          
            <button kendoButton *ngIf="user?.isGlobalUser" tabindex="0" class="!k-p-0 k-text-primary k-cursor-pointer assign-btn"
              fillMode="link" (click)="showReAssign$.next(true)">
              (Assign)
            </button>
          </div>
        </div>
        <div class="info-block">
          <p class="info-label">Next Annual Review</p>
          <p class="info-value">
            <span aria-hidden="true">{{ studentIEP?.annualRevDate | formatDate }}</span>
            <span class="k-sr-only" *ngIf="studentIEP?.annualRevDate">{{ studentIEP?.annualRevDate | formatDate : 'MMMM,
              Do, YYYY' }}</span>
          </p>
        </div>
        <div class="info-block">
          <p class="info-label">{{studentDetails?.isPreSchool ? 'EI Extension Date' : 'Next 3 Yr Reeval'}}</p>
          <p class="info-value">
            <span aria-hidden="true">{{ (studentDetails?.isPreSchool ? studentIEP?.extensionDate :
              studentIEP?.mandated3YearDate) | formatDate }}</span>
            <span class="k-sr-only"
              *ngIf="studentDetails?.isPreSchool ? studentIEP?.extensionDate : studentIEP?.mandated3YearDate">{{
              (studentDetails?.isPreSchool ? studentIEP?.extensionDate :
              studentIEP?.mandated3YearDate) | formatDate : 'MMMM, Do, YYYY' }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="student-status-strip" [class.red-alert-strip]="redAlertContact" *ngIf="!isCaseClosed && studentDetails">
    <div class="status-container">
      <span class="stage-text">
        {{ studentData?.caseStage }}
      </span>

      <div class="icons-group" kendoTooltip position="bottom">
        <kendo-avatar size="small" rounded="none" fillMode="none" [svgIcon]="hand"
          class="iconsList hand {{ studentData?.referralColor }}" title="Referrals">
        </kendo-avatar>

        <kendo-avatar size="small" rounded="none" fillMode="none" [svgIcon]="magnifyingGlass"
          class="iconsList {{ studentData?.evalColor }}" title="Evaluations">
        </kendo-avatar>

        <kendo-avatar size="small" rounded="none" fillMode="none" [svgIcon]="fileSignature"
          class="iconsList {{ studentData?.iepColor }}" title="IEP">
        </kendo-avatar>

        <kendo-avatar size="small" rounded="none" fillMode="none" [svgIcon]="graduationCap"
          class="iconsList {{ studentData?.placementColor }}" title="Placement">
        </kendo-avatar>
      </div>

      <span>|</span>

      <span class="stage-text"> {{ studentData?.activity }}</span>
      <span>|</span>
    </div>
    <!--<div class="k-d-flex">
    <span class="alert k-d-flex k-align-items-center">
      <fa-icon icon="triangle-exclamation" style="font-size: 14px"></fa-icon>Schedule IEP Meeting: 07/29/2025 (-91 Days)
    </span>
    <span class="k-mx-2">|</span>
    <span class="alert k-d-flex k-align-items-center">
      <fa-icon icon="triangle-exclamation" style="font-size: 14px"></fa-icon>Request Placement: 09/11/2025 (-19 Days)
    </span>
  </div>-->
  </div>

  <div class="studentProfile" *ngIf="studentDetails">
    <div class="container red-alert k-p-4 form-error" *ngIf="redAlertContact">
      <p class="!k-m-0 !k-font-semibold">
        There is a Red Alert associated with this student. The following adult(s)
        cannot have access to the student or any identifying information
        associated with the student:
      </p>
      <p class="!k-m-0 !k-font-semibold">
        1. {{ redAlertContact?.firstName }} {{ redAlertContact?.lastName }}
      </p>
      <p class="!k-m-0 !k-font-semibold">
        Keep student information from view of the adult(s) listed above and close
        the student information screen.
      </p>
    </div>
  </div>
  <!-- <div class="container-style" *ngIf="studentData?.studentStatus === 'Closed'">
    <div class="case-close-card">
      <button kendoButton size="medium" themeColor="dark" rounded="large" class="back-color">
        CASE CLOSED
      </button>
      <div class="k-d-row">
        <div>
          <b>
            {{ studentData?.firstName }}'s case was closed on
            {{ studentData?.caseCloseDate | date : "MM/dd/yyyy" }}.
          </b>
        </div>
        <div class="k-d-flex k-gap-2">
          <div>Total closures: {{ studentData?.noOfClosures }}</div>
          <div>|</div>
          <div>Reason: {{ studentData?.reasonforCasecloseDesc }}</div>
        </div>
      </div>
    </div>
  </div> -->
</div>

<kendo-dialog *ngIf="showRfdDialog$ | async" [title]="canEdit ? 'Add Reason for Delay' : 'View Reason for Delay'"
  (close)="rfd.onCloseClick()" [width]="786" [height]="'90vh'" [minWidth]="'1166'" (click)="$event.stopPropagation()">
  <app-reason-for-delay #rfd [studentDetails]="studentDetails" [referralsk]="referralSk"
    [studentSk]="studentDetails?.studentSk" [nycId]="studentDetails?.nycId" [eiId]="studentDetails?.eiId"
    [isPreSchool]="studentDetails?.isPreSchool" (close)="displayRfdDialog($event)" (saveEmitter)="onRfdSaved()"
    [canEdit]="canEdit">
  </app-reason-for-delay>
  <kendo-dialog-actions>
    <button kendoButton [fillMode]="'solid'" [themeColor]="'primary'" *ngIf="canEdit"
      [disabled]="!rfd.hasActiveReasons || rfd.loadSpinner" (click)="rfd.save()">Save</button>
  </kendo-dialog-actions>
</kendo-dialog>

<app-reassign-dialog *ngIf="showReAssign$ | async" (closeDialog)="showReAssign$.next(false)" (assignmentCompleted)="onAssignmentCompleted()"
  [studentSk]="studentDetails?.studentSk" [nycId]="nycId" [isReAssign]="isReAssign">
</app-reassign-dialog>

<app-capture-first-attend-date-dialog [nycId]="nycId" *ngIf="showCaptureFirstAttendDate$ | async"
  (closeDialog)="showCaptureFirstAttendDate$.next(false)">
</app-capture-first-attend-date-dialog>

<app-document-upload *ngIf="showUpload$ | async" (closeDialog)="showUpload$.next(false)"
  [studentDetails]="studentDetails" [referralSk]="referralSk" [nycId]="nycId" [isPreschool]="isPreschool"
  [caseActionSk]="actionsList?.iep?.stageSk"></app-document-upload>

<kendo-dialog *ngIf="showCloseRequestForReevaluationDialog$ | async"
  (close)="showCloseRequestForReevaluationDialog$.next(false)" class="shm-window" [maxWidth]="1900" [width]="700"
  [minHeight]="300" [animation]="{ duration: 300, type: 'fade', direction: 'down' }" [themeColor]="'primary'"
  title="Close Request for Reevaluation">
  <app-close-request-for-reevaluation [referralSk]="referralSk" [iepType]="pwn"
    (closeDialog)="showCloseRequestForReevaluationDialog$.next(false)">
  </app-close-request-for-reevaluation>
</kendo-dialog>

<kendo-dialog *ngIf="showCancelMeetingDialog$ | async" (close)="showCancelMeetingDialog$.next(false)" class="shm-window"
  (keydown.enter)="$event.stopPropagation()" (click)="$event.stopPropagation()" [maxWidth]="1900" [width]="1400"
  [minHeight]="300" [animation]="{ duration: 300, type: 'fade', direction: 'down' }" [themeColor]="'primary'"
  title="Cancel Meeting">
  <app-cancel-meeting [studentSk]="studentSk" (closeDialog)="showCancelMeetingDialog$.next(false)">
  </app-cancel-meeting>
</kendo-dialog>

<app-schedule-meeting [nycIds]="nycId" *ngIf="showScheduleMeetingDialog$ | async"
  (closeEmitter)="showScheduleMeetingDialog$.next(false)" [meetingType]="meetingType" [referralSk]="referralSk"
  [meetingSk]="meetingSk" [viewMode]="isViewMode" [regComplianceDate]="studentData?.complianceDate"
  [caseStage]="studentDetails?.caseStage" [meetingRoster]="meetingRoster" [actionText]="actionText">
</app-schedule-meeting>

<kendo-dialog title="Case Closing" *ngIf="showCaseClosingEventsDialog$ | async"
  (close)="showCaseClosingEventsDialog$.next(false)" [maxWidth]="1900" [width]="786" [maxHeight]="'90vh'"
  [minHeight]="300" [animation]="{ duration: 300, type: 'fade', direction: 'down' }">
  <app-case-closing [studentSk]="studentDetails?.studentSk" [complianceStatus]="studentData?.complianceStatus"
    [referralSk]="referralSk" (closeDialog)="showCaseClosingEventsDialog$.next(false)" [stdentDetails]="studentDetails"
    [eiId]="studentDetails?.eiId">
  </app-case-closing>
</kendo-dialog>


<kendo-dialog *ngIf="showAmendDialog$ | async" [width]="550" [height]="250" [minWidth]="350"
  (close)="onAmendDialogClose($event)" title="Are you sure">
  <p>This action will create an IEP Amendment, do you want to proceed?</p>

  <kendo-dialog-actions>
    <button kendoButton (click)="onAmendDialogClose({ text: 'No' })">No</button>
    <button kendoButton themeColor="primary" (click)="onAmendDialogClose({ text: 'Yes' })">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog *ngIf="showAnnualDialog$ | async" [width]="550" [height]="250" [minWidth]="350"
  (close)="onAnnualDialogClose($event)" title="Are you sure">

  <p>This action will create a new Annual Review IEP, do you want to proceed?</p>

  <kendo-dialog-actions>
    <button kendoButton (click)="onAnnualDialogClose({ text: 'No' })">No</button>
    <button kendoButton themeColor="primary" (click)="onAnnualDialogClose({ text: 'Yes' })">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog *ngIf="showRemoveMDEDialog$ | async" [width]="550" [height]="250" [minWidth]="350"
  (close)="onRemoveMDEWorklistDialogClose($event)" title="Please Confirm">

  <p>If you proceed, the student's record will be removed from this evaluation site. Are you sure to proceed?</p>

  <kendo-dialog-actions>
    <button kendoButton (click)="onRemoveMDEWorklistDialogClose({ text: 'No' })">No</button>
    <button kendoButton themeColor="primary" (click)="onRemoveMDEWorklistDialogClose({ text: 'Yes' })">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>
<app-edit-student-profile [studentDetails]="studentDetails" *ngIf="showEditStudentProfileDialog"
  (closeDialog)="closeEditStudentProfileDialog($event)">
</app-edit-student-profile>

<div *ngIf="isCreatingIep" class="create-iep-navigation-overlay" role="status"
  aria-label="Creating IEP and opening the IEP page">
  <kendo-loader type="converging-spinner" size="large"></kendo-loader>
</div>